var _desc, _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapTileProjectcompany(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "150px",
    height: "150px",
    viewBox: "0 0 150 150",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "map-tile-projectcompany") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 72.5,
    cy: 57.5,
    r: 41.5
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "map-tile-projectcompany"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Project-Map-Icon-Circle-Default",
    transform: "translate(2.000000, 16.000000)",
    fillOpacity: 0.1,
    fill: "#2E8FFA"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Square",
    transform: "translate(3.000000, 52.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74.9246481,0.728520014 L137.960144,23.2411971 C140.679952,24.2125571 140.679952,25.7874429 137.960144,26.7588029 L74.9246481,49.27148 C72.2048401,50.24284 67.7951599,50.24284 65.0753519,49.27148 L2.03985604,26.7588029 C-0.679952013,25.7874429 -0.679952013,24.2125571 2.03985604,23.2411971 L65.0753519,0.728520014 C67.7951599,-0.242840005 72.2048401,-0.242840005 74.9246481,0.728520014 Z",
    id: "Rectangle-2"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Oval-2"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Contract-signed",
    mask: "url(#mask-2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(37.000000, 24.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.8604651,38.8888889 C28.3560299,38.8888889 20.6511628,30.1833146 20.6511628,19.4444444 C20.6511628,8.70557431 28.3560299,0 37.8604651,0 C47.3649003,0 55.0697674,8.70557431 55.0697674,19.4444444 C55.0697674,30.1833146 47.3649003,38.8888889 37.8604651,38.8888889 Z M37.8604651,34.7953216 C45.3639666,34.7953216 51.4467564,27.9224998 51.4467564,19.4444444 C51.4467564,10.9663891 45.3639666,4.09356725 37.8604651,4.09356725 C30.3569636,4.09356725 24.2741738,10.9663891 24.2741738,19.4444444 C24.2741738,27.9224998 30.3569636,34.7953216 37.8604651,34.7953216 Z",
    id: "Oval-6",
    fill: "#51C47C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.343077,28.6788698 C36.5692803,29.0040674 36.8601128,29.1666667 37.2155745,29.1666667 C37.5710362,29.1666667 37.8618687,29.0040674 38.088072,28.6788698 L47.8467419,16.5446354 C48.0729452,16.2600869 48.1860465,15.8942392 48.1860465,15.4470924 C48.1860465,14.9999456 48.0729452,14.6340979 47.8467419,14.3495495 L46.0532749,12.1544635 C45.8270716,11.8292659 45.544318,11.6666667 45.2050135,11.6666667 C44.8657089,11.6666667 44.5667975,11.8292659 44.3082799,12.1544635 L37.2155745,20.9960691 L33.1335805,16.6058972 C32.875063,16.2806996 32.5761516,16.1181004 32.236847,16.1181004 C31.8975424,16.1181004 31.6147889,16.2806996 31.3885856,16.6058972 L29.5951185,18.8009832 C29.3689152,19.0855316 29.255814,19.4513793 29.255814,19.8985261 C29.255814,20.3456729 29.3689152,20.7115206 29.5951185,20.9960691 L36.343077,28.6788698 Z",
    id: "check",
    fill: "#51C47C"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(36.772365, 41.190750) rotate(-19.000000) translate(-36.772365, -41.190750) translate(3.214225, 25.635195)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-8",
    fill: "#FFFFFF",
    points: "0.252307908 0.615274553 34.0802869 0.615274553 66.9498581 29.7958298 33.1218791 29.7958298"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-2",
    fill: "#D8D8D8",
    points: "10.7020135 3.2660824 33.6567136 3.2660824 35.3423326 4.76252113 12.3876326 4.76252113"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-3",
    fill: "#D8D8D8",
    points: "14.9160611 7.00717923 37.8707611 7.00717923 38.7135707 7.75539859 15.7588706 7.75539859"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-3",
    fill: "#D8D8D8",
    points: "16.6016801 8.50361796 39.5563802 8.50361796 40.3991897 9.25183732 17.4444897 9.25183732"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-3",
    fill: "#D8D8D8",
    points: "18.2872992 10.0000567 41.2419992 10.0000567 42.0848087 10.7482761 19.1301087 10.7482761"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-3",
    fill: "#D8D8D8",
    points: "19.9729182 11.4964954 42.9276182 11.4964954 43.7704278 12.2447148 20.8157277 12.2447148"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-3",
    fill: "#D8D8D8",
    points: "21.6585372 12.9929341 44.6132373 12.9929341 45.4560468 13.7411535 22.5013468 13.7411535"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-3",
    fill: "#D8D8D8",
    points: "23.3441563 14.4893729 46.2988563 14.4893729 47.1416658 15.2375922 24.1869658 15.2375922"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-3",
    fill: "#D8D8D8",
    points: "25.0297753 15.9858116 47.9844753 15.9858116 48.8272849 16.734031 25.8725848 16.734031"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-3",
    fill: "#D8D8D8",
    points: "26.7153943 17.4822503 49.6700944 17.4822503 50.5129039 18.2304697 27.5582039 18.2304697"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-3",
    fill: "#D8D8D8",
    points: "34.30068 24.2162246 43.9658169 24.2162246 44.8086264 24.964444 35.1434895 24.964444"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-50",
    fill: "#CCCCCC",
    points: "72.4081472 42.3489297 72.4081472 52.3777558 40.6819584 66.0361794 40.6819584 54.4444444"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path-49",
    fill: "#E8E7E7",
    points: "0.965652199 39.3166205 0.965652199 49.8987047 40.8087841 66.1590049 40.8087841 54.524372"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    strokeWidth: 1,
    fill: "none",
    transform: "translate(27.534884, 11.666667)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.7808951,45.2893113 C40.0362469,44.9567539 40.2714021,44.7666017 40.4863607,44.7188547 C40.8087985,44.6472342 40.9549665,44.9437452 40.9984792,45.2893113 C41.041992,45.6348774 40.9879629,46.7034071 41.3250658,45.6348774 C41.6621687,44.5663477 41.901151,44.0263053 42.0494415,44.5663477 C42.1977321,45.1063902 42.049538,45.3366222 42.1977321,45.6348774 C42.3459261,45.9331326 43.1064821,45.9543898 43.0786957,45.3366222 C43.0509093,44.7188547 43.1342684,44.7639854 43.1064821,44.5663477 C43.0879578,44.4345893 43.1714456,44.6545011 43.3569455,45.2260833 C43.6580933,45.2366947 43.9114833,45.2577707 44.1171155,45.2893113 C44.4255637,45.3366222 44.1011962,45.8054803 44.6114816,45.9998476 C45.1217671,46.1942149 44.4560515,45.266964 44.4491049,44.7188547 C44.4421583,44.1707454 44.5196322,44.0197646 44.7489664,45.0071898 C44.9783006,45.994615 44.4027943,44.2374716 45.171744,45.1919698 C45.9406937,46.1464679 45.2771972,45.4656917 45.9406937,45.879717 C46.6041902,46.2937423 47.2295769,46.1199781 47.5518219,45.9998476 C47.8740668,45.879717 50.1158168,47.0073309 47.5969034,46.5222302 C45.0779901,46.0371295 45.7444523,46.7549695 45.4580982,46.5222302 C45.171744,46.2894908 44.0337563,45.4857498 43.9340919,45.879717 C43.8344276,46.2736842 43.9340919,45.8706691 43.9340919,46.5222302 C43.9340919,47.1737913 44.300139,45.8033 44.1171155,46.8256089 C43.9340919,47.8479177 43.4789933,46.2747743 43.4991578,46.1373109 C43.5193222,45.9998476 43.141601,46.2094765 42.9741108,46.2747743 C42.8624507,46.3183062 42.6036578,46.3400721 42.1977321,46.3400721 C42.054555,46.4752463 41.9442134,46.4752463 41.8667074,46.3400721 C41.7504484,46.1373109 41.9019228,46.1199781 41.7504484,45.9998476 C41.598974,45.879717 40.4239378,46.1579141 40.3564979,46.3400721 C40.289058,46.5222302 40.6433345,46.549592 40.4239378,46.8256089 C40.2045411,47.1016257 40.0466025,47.4095829 39.9976868,46.5222302 C39.9650764,45.9306617 39.8928125,45.5196887 39.7808951,45.2893113 Z",
    id: "Path-51",
    fill: "#2E8FFA",
    transform: "translate(44.279767, 45.727487) rotate(-17.000000) translate(-44.279767, -45.727487) "
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapTileProjectcompany);
export default __webpack_public_path__ + "static/media/map-tile-projectcompany.3b19f889.svg";
export { ForwardRef as ReactComponent };